import { FormConfigType } from '../../../types/zodSchemaTypes';

import { FormConfigDTO } from '../../dtos/forms.dtos';

export const getFormSegmentConfigTransformer = (
  data: FormConfigType
): FormConfigDTO => {
  const {
    title,
    instructions_text,
    submit_button_id,
    segment_events_types,
    should_send_segment_event,
    dependent_form_info,
    query_param_key,
    form_submission_type,
    google_analytics_events,
    enable_postmessage,
    enable_otp_autofill
  } = data;

  const formConfig: FormConfigDTO = {
    title,
    instructionsText: instructions_text ? instructions_text : undefined,
    submitButtonId: submit_button_id ? submit_button_id : undefined,
    segmentEventTypes: segment_events_types,
    shouldSendSegmentEvent: should_send_segment_event,
    dependentFormInfo: dependent_form_info
      ? {
          dependentFormId: dependent_form_info.dependent_form_id,
          description: dependent_form_info.description,
          navigationButtonText: dependent_form_info.navigation_button_text,
          navigationButtonId: dependent_form_info.navigation_button_id
        }
      : undefined,
    queryParamKey: query_param_key ? query_param_key : undefined,
    formSubmissionType: form_submission_type ? form_submission_type : undefined,
    googleAnalyticsEvents: google_analytics_events,
    enablePostMessage: enable_postmessage,
    enableOtpAutofill: enable_otp_autofill
  };
  return formConfig;
};
